import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useUser } from "./UserContext";
import buymoduleService from "../../services/BuyModule-service/buy-module-service";
import { handleErrors } from "../../utils/errorHandler";
import Cookies from "js-cookie";
const BuyWishlistContext = createContext();

export const BuyWishlistProvider = ({ children }) => {
  const { user } = useUser(); //from user context
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(false);


  const fetchBuyWishlist = async () => {
    if (!user.isAuthenticated) return;

    try {
      setLoading(true);
      const response = await buymoduleService.getWishlist();
      // console.log("resposne for getlist",response)
      setWishlist(response.data.result);
    } catch (error) {
      toast.error(handleErrors(error));
    } finally {
      setLoading(false);
    }
  };

 
  const addToBuyWishlist = async (propertGuid) => {
    if (!user.isAuthenticated) {
      toast.error("Please login to add items to wishlist");
      return;
    }
    try {
      const response = await buymoduleService.addWishlist(propertGuid);
      // console.log("after addding response",response)
      setWishlist((prev) => [...prev, response.data.result]);
      toast.success("Added to wishlist");
    } catch (error) {
      toast.error(handleErrors(error));
    }
  };

  const removeFromBuyWishlist = async (wishlistId) => {
    if (!user.isAuthenticated) {
      toast.error("Please login to remove items");
      return;
    }

    try {
      await buymoduleService.removeWishlist(wishlistId);
      setWishlist((prev) => prev.filter((item) => item.id !== wishlistId));
      toast.success("Removed from wishlist");
    } catch (error) {
      toast.error(handleErrors(error));
    }
  };


  useEffect(() => {
    const userRole = Cookies.get("userRole");
    if (user.isAuthenticated && userRole !== "O") {
      fetchBuyWishlist();
    } else {
      setWishlist([]);
    }
  }, [user.isAuthenticated]);

  return (
    <BuyWishlistContext.Provider
      value={{
        wishlist,
        loading,
        addToBuyWishlist,
        removeFromBuyWishlist,
        fetchBuyWishlist,
      }}
    >
      {children}
    </BuyWishlistContext.Provider>
  );
};

export const useBuyWishlist = () => useContext(BuyWishlistContext);
